import React, { useState, useEffect } from "react";
import "./CreateQuiz.css";
import { useTheme } from "../../context/ThemeContext";
import Card from "../Card";
import { createQuiz } from "../../api/api";

const CreateQuiz = ({ propQuestionSetId, handleUrl }) => {
    const { themeStyles } = useTheme();

    const [quizName, setQuizName] = useState("");
    const [quizDescription, setQuizDescription] = useState("");
    const [totalMarks, setTotalMarks] = useState("");
    const [timeLimit, setTimeLimit] = useState("");
    const [endDate, setEndDate] = useState("");
    const [error, setError] = useState("")
    const [success, setSuccess] = useState("");
    // const [quizType, setQuizType] = useState("");
    const [quizImage, setQuizImage] = useState(null);
    const [quizImageBase64, setQuizImageBase64] = useState("");
    const [quizNumber, setQuizNumber] = useState("");
    const [questionSetId, setQuestionSetId] = useState(propQuestionSetId);
    const [batch, setBatch] = useState("");

    useEffect(() => setQuestionSetId(propQuestionSetId), [propQuestionSetId])

    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent form reload

        // Check required fields
        if (!quizName || !quizDescription || !totalMarks || !timeLimit || !endDate || !batch) {
            setError("All required fields must be filled!");
            return;
        }

        const quizDetails = {
            name: quizName,
            quizNumber,
            quizPicture: quizImageBase64,
            description: quizDescription,
            totalMarks,
            timeLimit,
            quizType: "slide",
            endDate,
            batch,
            questionSetId
        };

        console.log("quiqui", quizDetails);

        try {
            const response = await createQuiz(quizDetails);
            setSuccess(response.message || "Quiz Created Successfully");
            // Reset form
            setQuizName("");
            setError("");
            setQuizDescription("");
            setTotalMarks("");
            setTimeLimit("");
            setEndDate("");
            handleUrl(response.link);
        } catch (err) {
            setError(
                err.response?.data?.message || "An error occurred during registration."
            );
        }
    };

    // Function to handle quiz image upload and convert to Base64
    const handleQuizImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setQuizImage(file);
                setQuizImageBase64(reader.result); // Base64 string
            };
            reader.readAsDataURL(file); // Convert image to Base64
        }
    };

    return (
        <Card>
            <form
                className="quiz-form"
                style={{
                    color: themeStyles.text,
                }}
                onSubmit={handleSubmit}
            >
                <div className="flex items-center space-x-4 p-4 border rounded-lg bg-white shadow-sm mb-4" style={{
                    background: themeStyles.cardContentBackground,
                    color: themeStyles.text,
                    border: `1px solid ${themeStyles.text}`,
                }}>
                    {/* Image Preview */}
                    {quizImage && quizImageBase64 !== "" && (
                        <div className="w-[120px] h-[120px] flex-shrink-0 rounded-lg overflow-hidden border border-gray-300">
                            <img
                                src={quizImageBase64}
                                alt="Uploaded Quiz"
                                className="w-full h-full object-cover"
                                style={{
                                    background: 'transparent',
                                    color: themeStyles.text,
                                }}
                            />
                        </div>
                    )}

                    {/* Image Upload Input */}
                    <div className="flex-1">
                        <label className="block text-sm font-medium text-gray-700 mb-2" style={{
                            color: themeStyles.text,
                        }}>
                            Upload Quiz Image:
                        </label>
                        <input
                            type="file"
                            onChange={handleQuizImageUpload} // Replace with your upload handler
                            className="block w-full text-sm border border-gray-300 rounded-lg p-2 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            style={{
                                color: themeStyles.text,
                                background: 'transparent'
                            }}
                        />
                    </div>
                </div>


                <div className="form-row">
                    <div className="form-group">
                        <label htmlFor="quizName">Paper Name*</label>
                        <input
                            type="text"
                            id="quizName"
                            value={quizName}
                            onChange={(e) => setQuizName(e.target.value)}
                            placeholder="Enter the quiz name"
                            required
                            style={{
                                background: themeStyles.cardContentBackground,
                                color: themeStyles.text,
                                border: `1px solid ${themeStyles.text}`,
                            }}
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="quizNumber">Paper Number*</label>
                        <input
                            type="text"
                            id="quizNumber"
                            value={quizNumber}
                            onChange={(e) => setQuizNumber(e.target.value)}
                            placeholder="Enter Paper Number"
                            required
                            style={{
                                background: themeStyles.cardContentBackground,
                                color: themeStyles.text,
                                border: `1px solid ${themeStyles.text}`,
                            }}
                        />
                    </div>
                </div>




                <div className="form-row">
                    <div className="form-group">
                        <label htmlFor="endDate">Expiration Date*</label>
                        <input
                            type="date"
                            id="endDate"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                            required
                            style={{
                                background: themeStyles.cardContentBackground,
                                color: themeStyles.text,
                                border: `1px solid ${themeStyles.text}`,
                            }}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="batch">Batch*</label>
                        <select
                            className="w-full py-2 border rounded-md focus:outline-none focus:ring-2"
                            style={{
                                backgroundColor: themeStyles.cardContentBackground,
                                color: themeStyles.text,
                                borderColor: themeStyles.text,
                                height: "65%"

                            }}
                            onChange={(e) => { if (e.target.value !== "select") setBatch(e.target.value) }}
                        >
                            <option value="select">Select Batch</option>
                            <option value="BSC1">BCS-I</option>
                            <option value="BSC2">BSC-II</option>
                            <option value="BSC3">BSC-III</option>
                        </select>
                    </div>
                    {/* <div className="form-group" style={{ display: "flex", flexDirection: "column" }}>
                        <label htmlFor="quizType" style={{ marginBottom: "8px" }}>Quiz Type*</label>
                        <div style={{ display: "flex", gap: "20px", alignItems: "center", flexWrap: "nowrap", marginTop: 10 }}>
                            <label style={{ display: "flex", alignItems: "center", gap: "5px", whiteSpace: "nowrap" }}>
                                <input
                                    type="radio"
                                    id="listView"
                                    name="quizType"
                                    value={quizType}
                                    checked={quizType === "listView"}
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            setQuizType("listView")
                                        }
                                    }}
                                />
                                List View
                            </label>
                            <label style={{ display: "flex", alignItems: "center", gap: "5px", whiteSpace: "nowrap" }}>
                                <input
                                    type="radio"
                                    id="slideView"
                                    name="quizType"
                                    value={quizType}
                                    checked={quizType === "slideView"}
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            setQuizType("slideView")
                                        }
                                    }}
                                />
                                Slide View
                            </label>
                        </div>
                    </div> */}

                </div>

                <div className="form-row">
                    <div className="form-group">
                        <div>
                            <label htmlFor="totalMarks">Total Marks</label>
                            <input
                                type="number"
                                id="totalMarks"
                                value={totalMarks}
                                onChange={(e) => setTotalMarks(e.target.value)}
                                placeholder="Enter total marks for the quiz"
                                required
                                style={{
                                    background: themeStyles.cardContentBackground,
                                    color: themeStyles.text,
                                    border: `1px solid ${themeStyles.text}`,
                                }}
                            />

                        </div>

                    </div>
                    <div className="form-group">
                        <div>
                            <label htmlFor="totalMarks">Time Limit</label>
                            <input
                                type="number"
                                id="timeLimit"
                                value={timeLimit}
                                onChange={(e) => setTimeLimit(e.target.value)}
                                placeholder="Enter time limit in minute"
                                required
                                style={{
                                    background: themeStyles.cardContentBackground,
                                    color: themeStyles.text,
                                    border: `1px solid ${themeStyles.text}`,
                                }}
                            />

                        </div>

                    </div>

                </div>

                <div className="form-group">
                    <label htmlFor="quizDescription">Quiz Description</label>
                    <textarea
                        id="quizDescription"
                        value={quizDescription}
                        onChange={(e) => setQuizDescription(e.target.value)}
                        placeholder="Provide a brief description of the quiz"
                        required
                        style={{
                            background: themeStyles.cardContentBackground,
                            color: themeStyles.text,
                            border: `1px solid ${themeStyles.text}`,
                        }}
                    />
                </div>

                {/* Error and Success Messages */}
                {error && <p className="error-message">{error}</p>}
                {success && <p className="success-message">{success}</p>}



                <div className="card-footer">
                    {/* Settings Button */}
                    {/* <button className="card-button left">
                        <img src={settingIcon} alt="Setting Icon" className="sidebar-icon" />
                        Settings
                    </button> */}

                    {/* Generate Questions Button */}
                    <button className="card-button center bg-custom-blue">
                        Create Quiz
                    </button>
                </div>
            </form>
        </Card>
    );
};

export default CreateQuiz;
